[
  "https://accounts.wdtest1.com",
  "https://sb-03-kepler.wdtest1.com/static/auth",
  "kepler://authorize",
  "http://localhost:3000",
  "https://sb-03-yoda.wdtest1.com",
  "http://localhost:1234"
]
